import StoreApplicationState from "@store/Store/StoreApplicationState";

export function getPaymentHistoryParameters(state: StoreApplicationState) {
    return {
        ...state.store.pages.paymentHistory.getPaymentHistoryParameter,
        ...state.store.pages.paymentHistory.dirtyFilters,
    };
}
